import { type Ref, nextTick, onMounted, onUnmounted, watch } from "vue";

export const useAutoScrollToBottom = (
    scrollEl: Ref<HTMLElement | null>,
    trigger: Ref<unknown>,
    threshold = 80
) => {
    let pinned = true;
    let attached: HTMLElement | null = null;

    const isAtBottom = () => {
        const el = scrollEl.value;
        if (!el) return true;
        return el.scrollHeight - el.scrollTop - el.clientHeight < threshold;
    };

    const scrollToBottom = () => {
        const el = scrollEl.value;
        if (!el) return;
        el.scrollTop = el.scrollHeight;
    };

    const onScroll = () => {
        pinned = isAtBottom();
    };

    const attach = () => {
        const el = scrollEl.value;
        if (attached === el) return;
        if (attached) attached.removeEventListener("scroll", onScroll);
        attached = el;
        if (attached) {
            attached.addEventListener("scroll", onScroll, { passive: true });
        }
    };

    watch(trigger, async () => {
        const wasPinned = pinned;
        await nextTick();
        if (wasPinned) {
            scrollToBottom();
            pinned = true;
        }
    });

    watch(scrollEl, async () => {
        await nextTick();
        attach();
        if (pinned) scrollToBottom();
    });

    onMounted(async () => {
        await nextTick();
        attach();
        scrollToBottom();
    });

    onUnmounted(() => {
        if (attached) attached.removeEventListener("scroll", onScroll);
    });
};
